import { gql } from '@apollo/client'
export const CreateAppProject = gql`
mutation CreateAppProject($name: String!, $platform: AppPlatform!, $description: String, $members: [String], $icon: String, $buildleId: String, $version: String, $bundleVersion: String, $minimumOsVersion: String, $teamName: String, $timeTolLive: String, $packageName: String, $versionName: String, $versionCode: String, $minSdkVersion: String, $targetSdkVersion: String) {
  createAppProject(name: $name, platform: $platform, description: $description, members: $members, icon: $icon, buildleID: $buildleId, version: $version, bundleVersion: $bundleVersion, minimumOSVersion: $minimumOsVersion, teamName: $teamName, timeTolLive: $timeTolLive, packageName: $packageName, versionName: $versionName, versionCode: $versionCode, minSdkVersion: $minSdkVersion, targetSdkVersion: $targetSdkVersion) {
    _id
    projectName
    platform
    description
    owner
    members
    totalDownload
    hasPassword
    password
    limit {
      downloadMax
    }
    icon
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
  }
}
`
export const DeleteAppProject = gql`
mutation DeleteAppProject($deleteAppProjectId: String!) {
  deleteAppProject(id: $deleteAppProjectId)
}
`
export const UploadApp = gql`
mutation UploadApp($projectId: String!, $platform: AppPlatform!, $fileName: String!, $size: Float!, $description: String, $icon: String, $buildleId: String, $version: String, $bundleVersion: String, $minimumOsVersion: String, $teamName: String, $timeTolLive: String, $packageName: String, $versionName: String, $versionCode: String, $minSdkVersion: String, $targetSdkVersion: String) {
  uploadApp(projectId: $projectId, platform: $platform, fileName: $fileName, size: $size, description: $description, icon: $icon, buildleID: $buildleId, version: $version, bundleVersion: $bundleVersion, minimumOSVersion: $minimumOsVersion, teamName: $teamName, timeTolLive: $timeTolLive, packageName: $packageName, versionName: $versionName, versionCode: $versionCode, minSdkVersion: $minSdkVersion, targetSdkVersion: $targetSdkVersion) {
    _id
    description
    icon
    platform
    createdAt
    url
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
  }
}
`

export const GetAppInfoList = gql`
query GetAppInfoList($projectId: String!) {
  getAppInfoList(projectId: $projectId) {
    _id
    description
    icon
    platform
    createdAt
    url
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
  }
}
`

export const GetAppInfo = gql`
query GetAppInfo($id: String!) {
  getAppInfo(_id: $id) {
    _id
    description
    createdAt
    platform
    url
    version
  }
}
`

export const GetAppDownloadUrl = gql`
query Query($id: String!, $password: String) {
  getAppDownloadUrl(_id: $id, password: $password)
}
`

export const GetAppProjectList = gql`
query Query($platform: AppPlatform) {
  getAppProjectList(platform: $platform) {
    _id
    projectName
    platform
    description
    icon
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
    owner
    latestApp{
    version
    bundleVersion
    versionName
    versionCode
    }
  }
}
`
export const EditAppInfo = gql`
mutation EditAppInfo($editAppInfoId: String!, $description: String, $icon: String) {
  editAppInfo(id: $editAppInfoId, description: $description, icon: $icon) {
    _id
    description
    icon
    version
    platform
    createdAt
    url
  }
}
`
export const GetMembersList = gql`
query Query {
  getMembersList
}
`
export const DeleteApp = gql`
mutation DeleteApp($deleteAppId: String!) {
  deleteApp(id: $deleteAppId)
}
`
export const GetAppProject = gql`
query GetAppProject($getAppProjectId: String!) {
  getAppProject(id: $getAppProjectId) {
    _id
    projectName
    platform
    description
    owner
    members
    totalDownload
    hasPassword
    password
    limit {
      downloadMax
    }
    icon
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
  }
}
`
export const EditAppProject = gql`
mutation Mutation($editAppProjectId: String!, $limit: Int, $password: String, $members: [String], $description: String) {
  editAppProject(id: $editAppProjectId, limit: $limit, password: $password, members: $members,description: $description) {
    _id
    projectName
    platform
    description
    owner
    members
    totalDownload
    hasPassword
    password
    limit {
      downloadMax
    }
    icon
    buildleID
    version
    bundleVersion
    minimumOSVersion
    teamName
    timeTolLive
    packageName
    versionName
    versionCode
    minSdkVersion
    targetSdkVersion
  }
}
`

